import React, { createContext, useReducer } from 'react';
import Reducer from './reducer';

const initialState = {
  loading: {},
  userObjects: {},
};

const UserObjectStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <UserObjectContext.Provider value={[state, dispatch]}>{children}</UserObjectContext.Provider>
  );
};

export const UserObjectInitialState = initialState;
export const UserObjectContext = createContext(initialState);
export default UserObjectStoreProvider;
